import { Component, ElementRef, ViewChild, OnInit, Input, OnChanges } from '@angular/core';
import { ACustomStepWizard } from '../../../shared/components/wizard/step-wizard/abstract-custom-step-wizard';
import { Observable, of } from 'rxjs';
import { InfoDialogComponent } from '../../../shared/components/info-dialog/info-dialog.component';
import { IFacadeExportObject } from 'app/core/typings/IFacadeExportObject';

@Component({
  selector: 'app-export-step40',
  templateUrl: './export-step40.component.html',
  styleUrls: ['./export-step40.component.scss', '../../sync-data.component.scss']
})
export class ExportStep40Component extends ACustomStepWizard<{ syncData: IFacadeExportObject }> implements OnChanges {
  @Input() data;
  @ViewChild('infoDialog', { static: false }) infoDialog: InfoDialogComponent;
  @ViewChild('fileUpload', { static: false }) fileUploader: ElementRef;

  public isLoading = false;
  public showError = false;
  public errorMessage: string;

  constructor() {
    super('');
  }

  ngOnChanges(): void {
    if (this.data) {
      this.data.syncData.OverrideTargetResources = true;
      this.load();
    }
  }

  public isValid(): Observable<boolean> {
    let validation = true;
    if (!this.data.syncData.FilePath || this.data.syncData.FilePath.length === 0) {
      validation = false;
      this.showError = true;
      this.errorMessage = 'SYNC_DATA.MUST_SELECT_THE_FILE';
    }
    return of(validation);
  }

  public addFiles() {
    this.fileUploader.nativeElement.click();
  }

  public onFilesAdded() {
    if (this.fileUploader.nativeElement.files[0]) {
      this.showError = false;
      this.data.syncData.FileToImport = this.fileUploader.nativeElement.files[0];
      this.data.syncData.FilePath = this.data.syncData.FileToImport.name;
      this.fileUploader.nativeElement.value = '';
    }
  }
  public setData(data) {
    this.data = _.extend(this.data, data);
  }
}
